import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-highlighted-network-measurements',
  templateUrl: './highlighted-network-measurements.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HighlightedNetworkMeasurementsComponent {
  @Input() category: string = 'warning';

  @Input() dataUtilization: string = '0';

  @Input() latency: string = '0';

  @Input() jitter: string = '0';

  @Input() packetLost: string = '0';

  get severityLabel(): string {
    if (this.category === 'critical') return 'critical';
    if (this.category === 'warning') return 'warning';
    return 'normal';
  }
}
